<template>
    <div v-loading="loading">
        <div style="text-align: center">
            <span class="name-label">{{companyname}}</span>
        </div>

        <div class="select-area-box">
            <div>
                <span tkey="樓層">{{i18n.tkey("lang_floor_num")}}</span>
                <br>
                <el-select
                    v-model="currPosition.addinfo1"
                    filterable
                    :placeholder="i18n.tkey('lang_floor_num')"
                    size="large"
                    style=""
                >
                    <el-option
                        v-for="i in maxAreaNum"
                        :key="i"
                        :label="i"
                        :value="i"
                    />
                </el-select>
            </div>

            <div>
                <span tkey="門牌號">{{i18n.tkey("lang_doornum_text")}}</span>
                <br>
                <el-select
                    v-model="currPosition.addinfo2"
                    filterable
                    :placeholder="i18n.tkey('lang_doornum_text')"
                    size="large"
                    style=""
                >
                    <el-option
                        v-for="i in maxDoorNum"
                        :key="i"
                        :label="i"
                        :value="i"
                        :disabled="null != positionMap[currPosition.addinfo1] && null != positionMap[currPosition.addinfo1][i]"
                    />
                </el-select>
            </div>
        </div>

        <div style="text-align: center; margin-top: 40px">
            <el-button type="primary" @click="clickSave" tkey="保存">{{i18n.tkey("lang_save")}}</el-button>
        </div>

    </div>
</template>

<script setup>

import {inject, toRef, computed, onBeforeMount, ref, reactive} from "vue";
import {useUserinfo} from "@/stores/userinfo";
import myUtil from "@/util/util";
import record15Api from "@/request/record15Api";

const props = defineProps(["record", "type"])
const emits = defineEmits(["save-complete"])

const i18n = inject("i18n")
const userInfoRef = toRef(useUserinfo())

const loading = ref(false)
const positionMap = ref({})

const maxAreaNum = ref(99)
const maxDoorNum = ref(20)

const currPosition = reactive({
    addinfo1: null,
    addinfo2: null,
})

const companyname = computed(() => {
    let name = ""

    if (null != props.record && null != props.record.company){
        name = props.record.company.companyname2

        if (myUtil.isEmpty(name) || userInfoRef.value.lang == "zh" || userInfoRef.value.lang == "szh"){
            name = props.record.company.companyname
        }

    }

    return name

})

function getPostionStats(){
    const request = record15Api.queryAdditionalrecord15PositionStatus
    const params = request.getParams()

    params.updatedid = props.record.updatedid

    if (props.type == "-1"){
        params.addinfo14 = props.record.addinfo14
    }

    request.send(params, (res) => {
        loading.value = false

        if (res.code == 200){
            fillPositionMap(res.detail.list)
        }else {
            myUtil.alertError(res.msg)
        }

    })

}

function fillPositionMap(list){
    if (null != list){
        const map = {}

        list.forEach((v, i) => {
            if (null == map[v.addinfo1]){
                map[v.addinfo1] = {}
            }

            map[v.addinfo1][v.addinfo2] = v.id
        })

        positionMap.value = map
    }
}

function clickSave(){
    loading.value = true

    const request = record15Api.updateRecord15Position
    const params = request.getParams()

    params.id = props.record.id
    params.updatedid = props.record.updatedid
    params.addinfo1 = currPosition.addinfo1
    params.addinfo2 = currPosition.addinfo2

    request.send(params, (res) => {
        if (res.code == 200){
            myUtil.alertSuccess(i18n.tkey("lang_save_success"))
            emits("save-complete")
        }else if(res.code == 201){
            myUtil.alertError(i18n.tkey("lang_position_occupied"))
        }else{
            myUtil.alertError(res.msg)
        }
    })


}

onBeforeMount(() => {
    if (props.type == "-1"){
        maxDoorNum.value = 40
    }

    if (null != props.record){
        currPosition.addinfo1 = props.record.addinfo1
        currPosition.addinfo2 = props.record.addinfo2

        if (null != props.record.id){
            getPostionStats()
        }

    }
})

</script>

<style scoped>
    .select-area-box {
        display: flex;
        align-items: center;
        justify-content: space-around;
        margin-top: 30px;
    }

    .name-label {
        color: #303133;
        font-size: 1.2em;
        font-weight: 600;
    }
</style>